import { FC } from "react";
import { Link } from "react-router-dom";
import logoUrl from "../assets/images/cplogo.png";

export const Logo: FC = (props: any) => {
  return (
      <Link to="/">  <img src={logoUrl} alt="Logo" height="auto" width="100%" /></Link>
  );
};
